import * as svg from "../../../assets/houfy-icon-circle.svg";

import {iconBuilder} from "./iconBuilder";

export const HoufyCircleIcon = iconBuilder(svg, "HoufyCircleIcon", "0 0 80.6 74.4");
